import en from '@/services/i18n/en'

export default {
  en,
}
